export default __webpack_public_path__ + "static/media/maker.292f5cfd.svg";